import { render, staticRenderFns } from "./TreeSelect.vue?vue&type=template&id=72bdf5ba"
import script from "./TreeSelect.vue?vue&type=script&lang=js"
export * from "./TreeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72bdf5ba')) {
      api.createRecord('72bdf5ba', component.options)
    } else {
      api.reload('72bdf5ba', component.options)
    }
    module.hot.accept("./TreeSelect.vue?vue&type=template&id=72bdf5ba", function () {
      api.rerender('72bdf5ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Form/common/TreeSelect.vue"
export default component.exports